import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import config from "../config";
import { rgbToHex } from "../librairie";

export default function getStyleRondMaille2Variables (feature, bord = false, remplirlisteexport = true){
    var rougeaafficher = false;
    var jauneaafficher = false;
    var bleuaafficher = false;
    var donneesexport = [];
    var donneeexport = { "type": "Feature", "properties": { "afficher": true }, "geometry": { "type": "Point", "coordinates": feature.getGeometry().getCenter() } }
    donneeexport.properties["taillecercle"] = feature.getGeometry().getRadius();
    if (typeof feature.getProperties().nbre4 != "undefined" && feature.getProperties().nbre4 !== null) {
        donneeexport.properties["var4"] = parseFloat(feature.getProperties().nbre4);
    }
    bord = false;
    if (typeof feature.getProperties().nbre1 != "undefined" && feature.getProperties().nbre1 !== null) {
        rougeaafficher = false;
        if (feature.getProperties().operation1.signe === "inf") {
            rougeaafficher = parseFloat(feature.getProperties().nbre1) <= feature.getProperties().operation1.valeur;
        } else {
            rougeaafficher = parseFloat(feature.getProperties().nbre1) >= feature.getProperties().operation1.valeur;
        }
        if (rougeaafficher) {
            donneeexport.properties["var1"] = feature.getProperties().nbre1;
        }
    }

    if (typeof feature.getProperties().nbre2 != "undefined" && feature.getProperties().nbre2 !== null) {
        jauneaafficher = false;
        if (feature.getProperties().operation2.signe === "inf") {
            jauneaafficher = parseFloat(feature.getProperties().nbre2) <= feature.getProperties().operation2.valeur;
        } else {
            jauneaafficher = parseFloat(feature.getProperties().nbre2) >= feature.getProperties().operation2.valeur;
        }
        if (jauneaafficher) {
            donneeexport.properties["var2"] = feature.getProperties().nbre2;
        }
    }
    if (typeof feature.getProperties().nbre3 != "undefined" && feature.getProperties().nbre3 !== null) {
        bleuaafficher = false;
        if (feature.getProperties().operation3.signe === "inf") {
            bleuaafficher = parseFloat(feature.getProperties().nbre3) <= feature.getProperties().operation3.valeur;
        } else {
            bleuaafficher = parseFloat(feature.getProperties().nbre3) >= feature.getProperties().operation3.valeur;
        }
        if (bleuaafficher) {
            donneeexport.properties["var3"] = feature.getProperties().nbre3;
        }
    }

    var couleurremplissage = "";
    var couleurcontour = "";
    if (rougeaafficher && jauneaafficher && bleuaafficher && feature.getProperties().checkTheme1Theme2Theme3 ) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme123[0] + ',' + config.couleur_theme123[1] + ',' + config.couleur_theme123[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme123[0]) + rgbToHex(config.couleur_theme123[1]) + rgbToHex(config.couleur_theme123[2]);
    } else if (!rougeaafficher && jauneaafficher && bleuaafficher && feature.getProperties().checkTheme2Theme3) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme23[0] + ',' + config.couleur_theme23[1] + ',' + config.couleur_theme23[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme23[0]) + rgbToHex(config.couleur_theme23[1]) + rgbToHex(config.couleur_theme23[2]);
    } else if (rougeaafficher && !jauneaafficher && bleuaafficher && feature.getProperties().checkTheme1Theme3) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme13[0] + ',' + config.couleur_theme13[1] + ',' + config.couleur_theme13[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme13[0]) + rgbToHex(config.couleur_theme13[1]) + rgbToHex(config.couleur_theme13[2]);
    } else if (rougeaafficher && jauneaafficher && !bleuaafficher && feature.getProperties().checkTheme1Theme2) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme12[0] + ',' + config.couleur_theme12[1] + ',' + config.couleur_theme12[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme12[0]) + rgbToHex(config.couleur_theme12[1]) + rgbToHex(config.couleur_theme12[2]);
    } else if (!rougeaafficher && !jauneaafficher && bleuaafficher && feature.getProperties().checkTheme3) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme3[0] + ',' + config.couleur_theme3[1] + ',' + config.couleur_theme3[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme3[0]) + rgbToHex(config.couleur_theme3[1]) + rgbToHex(config.couleur_theme3[2]);
    } else if (rougeaafficher && !jauneaafficher && !bleuaafficher && feature.getProperties().checkTheme1) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme1[0] + ',' + config.couleur_theme1[1] + ',' + config.couleur_theme1[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme1[0]) + rgbToHex(config.couleur_theme1[1]) + rgbToHex(config.couleur_theme1[2]);
    } else if (!rougeaafficher && jauneaafficher && !bleuaafficher && feature.getProperties().checkTheme2) {
        couleurremplissage = couleurcontour = 'rgba(' + config.couleur_theme2[0] + ',' + config.couleur_theme2[1] + ',' + config.couleur_theme2[2] + ',1)';
        donneeexport.properties.couleur = "#FF" + rgbToHex(config.couleur_theme2[0]) + rgbToHex(config.couleur_theme2[1]) + rgbToHex(config.couleur_theme2[2]);
    } else {
        couleurremplissage = 'rgba(191,191,191,0)';
        couleurcontour = 'rgba(191,191,191,0)';
        donneeexport = "";
    }

    if (donneeexport !== "" && remplirlisteexport)
        donneesexport.push(donneeexport);
    return new Style({
        stroke: new Stroke({
            color: bord ? 'black' : couleurcontour,
            width: bord ? 2 : 0
        }),
        fill: new Fill({
            color: couleurremplissage
        })
    });
};